// extracted by mini-css-extract-plugin
export default {"tabs":"TabBar_tabs__PKXx1","tab":"TabBar_tab__0xR2J","activeTab":"TabBar_activeTab__9Fe-H","badge":"TabBar_badge__bdD3u","popIn":"TabBar_popIn__1wGP0"};